module.exports = __webpack_public_path__ + "static/media/kr.fb98f166.png";